var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9951 24.1421C47.9951 10.9657 37.3135 0.284119 24.1371 0.284119C10.9607 0.284119 0.279053 10.9657 0.279053 24.1421C0.279053 37.3186 10.9607 48.0002 24.1371 48.0002C37.3135 48.0002 47.9951 37.3186 47.9951 24.1421Z",
    fill: "url(#paint0_radial_100_2294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.0936 8.44615C38.6154 14.8313 33.6962 21.4174 27.5497 27.564C21.4031 33.7105 14.817 38.6203 8.44127 42.0985C8.04155 41.7511 7.65333 41.3891 7.27663 41.0124C4.99962 38.8114 3.18359 36.1791 1.93443 33.269C0.685265 30.3589 0.0279717 27.2292 0.000873508 24.0624C-0.0262247 20.8957 0.577415 17.7552 1.77659 14.8241C2.97577 11.8931 4.74649 9.23009 6.9855 6.99045C9.22451 4.75082 11.887 2.97936 14.8177 1.77936C17.7484 0.579363 20.8887 -0.0251526 24.0555 0.00106158C27.2223 0.0272757 30.3521 0.683695 33.2626 1.93204C36.173 3.18039 38.8059 4.99569 41.0075 7.27208C41.3842 7.64879 41.7462 8.04014 42.0936 8.44615Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6942 36.699V27.4886C36.6942 22.9807 35.7242 19.5118 30.4566 19.5118C27.9232 19.5118 26.2249 20.8994 25.5312 22.2178H25.459V19.9325H20.4645V36.699H25.663V28.3958C25.663 26.1984 26.0774 24.0951 28.8022 24.0951C31.5271 24.0951 31.5082 26.6065 31.5082 28.5371V36.699H36.6942Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9951 19.9325H17.2031V36.699H11.9951V19.9325Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5975 11.5853C13.9972 11.5822 13.4094 11.7575 12.9089 12.0891C12.4084 12.4206 12.0177 12.8934 11.7864 13.4474C11.5551 14.0014 11.4936 14.6116 11.6097 15.2006C11.7258 15.7896 12.0144 16.3308 12.4387 16.7556C12.8629 17.1803 13.4039 17.4694 13.9927 17.5861C14.5816 17.7029 15.1919 17.642 15.7462 17.4113C16.3004 17.1805 16.7736 16.7903 17.1056 16.2901C17.4377 15.79 17.6136 15.2024 17.6111 14.6021C17.6111 13.8025 17.2937 13.0357 16.7287 12.47C16.1636 11.9043 15.3971 11.5861 14.5975 11.5853Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_100_2294",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1371 24.1421) scale(23.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLk);
export default __webpack_public_path__ + "static/media/icon-lk.0df1f76e5b61cdc352d3ee04ee4940ef.svg";
export { ForwardRef as ReactComponent };